module.exports = __webpack_public_path__ + "img/cough.258be70c.png";